module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/server-pagination/server-pagination.component.css
// module id = ./src/app/examples/server-pagination/server-pagination.component.css
// module chunks = main